module.exports = __webpack_public_path__ + "static/media/ImageSet.a38916b4.png";